import { useMemo } from 'react';
import { Box, Button, Flex, Icon, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import BarChart from 'components/charts/BarChart';
import { MdBarChart } from 'react-icons/md';
import { useFinance } from 'contexts/FinanceContext';
import { barChartOptionsConsumption } from 'variables/charts';

export default function FinanceMonthlyRevenue(props: { [x: string]: any }) {
  const { ...rest } = props;
  const { monthlyData } = useFinance();
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const iconColor = useColorModeValue('brand.500', 'white');
  const bgButton = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');
  const bgHover = useColorModeValue({ bg: 'secondaryGray.400' }, { bg: 'whiteAlpha.50' });
  const bgFocus = useColorModeValue({ bg: 'secondaryGray.300' }, { bg: 'whiteAlpha.100' });

  const chartData = useMemo(
    () => [
      { name: 'Income', data: monthlyData.map((m) => m.income) },
      { name: 'Expense', data: monthlyData.map((m) => m.expense) },
    ],
    [monthlyData]
  );

  const chartOptions = useMemo(
    () => ({
      ...barChartOptionsConsumption,
      xaxis: {
        ...barChartOptionsConsumption.xaxis,
        categories: monthlyData.map((m) => m.month),
      },
    }),
    [monthlyData]
  );

  return (
    <Card alignItems="center" flexDirection="column" w="100%" {...rest}>
      <Flex align="center" w="100%" px="15px" py="10px">
        <Text
          me="auto"
          color={textColor}
          fontSize="xl"
          fontWeight="700"
          lineHeight="100%"
        >
          Monthly Overview
        </Text>
        <Button
          alignItems="center"
          justifyContent="center"
          bg={bgButton}
          _hover={bgHover}
          _focus={bgFocus}
          _active={bgFocus}
          w="37px"
          h="37px"
          lineHeight="100%"
          borderRadius="10px"
        >
          <Icon as={MdBarChart} color={iconColor} w="24px" h="24px" />
        </Button>
      </Flex>
      <Box h="240px" mt="auto" w="100%">
        {monthlyData.length > 0 ? (
          <BarChart chartData={chartData} chartOptions={chartOptions} />
        ) : (
          <Flex h="240px" align="center" justify="center" color="gray.400">
            No data yet
          </Flex>
        )}
      </Box>
    </Card>
  );
}
